//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './MeasurementMappingClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetMeasurementMappingQueryParameters = {
  measurementTypeId: number ;
  deviceModel: Types.DeviceModel ;
}

export type EditMeasurementMappingQueryParameters = {
  id: number ;
}

export type RemoveMeasurementMappingQueryParameters = {
  id: number ;
}

export function createUrl(): string {
  let url_ = getBaseUrl() + "/api/measurements/mappings";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createMutationKey(): MutationKey {
  return trimArrayEnd([
      'MeasurementMappingClient',
      'create',
    ]);
}

export function useCreateMutation<TContext>(options?: Omit<UseMutationOptions<Types.MeasurementMappingDto, unknown, Types.CreateMeasurementMappingDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.MeasurementMappingDto, unknown, Types.CreateMeasurementMappingDto, TContext> {
  const key = createMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.CreateMeasurementMappingDto) => Client.create(dto),
    mutationKey: key,
  });
}
  
export function getUrl(measurementTypeId: number, deviceModel: Types.DeviceModel): string {
  let url_ = getBaseUrl() + "/api/measurements/mappings?";
  if (measurementTypeId === undefined || measurementTypeId === null)
    throw new Error("The parameter 'measurementTypeId' must be defined and cannot be null.");
  else
    url_ += "measurementTypeId=" + encodeURIComponent("" + measurementTypeId) + "&";
  if (deviceModel === undefined || deviceModel === null)
    throw new Error("The parameter 'deviceModel' must be defined and cannot be null.");
  else
    url_ += "deviceModel=" + encodeURIComponent("" + deviceModel) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.MeasurementMappingDto[], unknown, Types.MeasurementMappingDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.MeasurementMappingDto[], unknown, Types.MeasurementMappingDto[]>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(dto: GetMeasurementMappingQueryParameters): QueryKey;
export function getQueryKey(measurementTypeId: number, deviceModel: Types.DeviceModel): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { measurementTypeId, deviceModel,  } = params[0] as GetMeasurementMappingQueryParameters;

    return trimArrayEnd([
        'MeasurementMappingClient',
        'get',
        measurementTypeId as any,
        deviceModel as any,
      ]);
  } else {
    return trimArrayEnd([
        'MeasurementMappingClient',
        'get',
        ...params
      ]);
  }
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
      context.queryKey[2] as number,       context.queryKey[3] as Types.DeviceModel,axiosConfig    );
}

export function useGetQuery<TSelectData = Types.MeasurementMappingDto[], TError = unknown>(dto: GetMeasurementMappingQueryParameters, options?: Omit<UseQueryOptions<Types.MeasurementMappingDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useGetQuery<TSelectData = Types.MeasurementMappingDto[], TError = unknown>(measurementTypeId: number, deviceModel: Types.DeviceModel, options?: Omit<UseQueryOptions<Types.MeasurementMappingDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.MeasurementMappingDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.MeasurementMappingDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let measurementTypeId: any = undefined;
  let deviceModel: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ measurementTypeId, deviceModel,  } = params[0] as GetMeasurementMappingQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [measurementTypeId, deviceModel, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.MeasurementMappingDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(measurementTypeId, deviceModel),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.MeasurementMappingDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setGetData(queryClient: QueryClient, updater: (data: Types.MeasurementMappingDto[] | undefined) => Types.MeasurementMappingDto[], measurementTypeId: number, deviceModel: Types.DeviceModel) {
  queryClient.setQueryData(getQueryKey(measurementTypeId, deviceModel),
    updater
  );
}

export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.MeasurementMappingDto[] | undefined) => Types.MeasurementMappingDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function editUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/measurements/mappings/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function editMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'MeasurementMappingClient',
      'edit',
      id as any,
    ]);
}

export function useEditMutation<TContext>(id: number, options?: Omit<UseMutationOptions<Types.MeasurementMappingDto, unknown, Types.UpdateMeasurementMappingDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.MeasurementMappingDto, unknown, Types.UpdateMeasurementMappingDto, TContext> {
  const key = editMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.UpdateMeasurementMappingDto) => Client.edit(id, dto),
    mutationKey: key,
  });
}
  
type Edit__MutationParameters = EditMeasurementMappingQueryParameters & {
  dto: Types.UpdateMeasurementMappingDto;
}

export function useEditMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.MeasurementMappingDto, unknown, Edit__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: EditMeasurementMappingQueryParameters}): UseMutationResult<Types.MeasurementMappingDto, unknown, Edit__MutationParameters, TContext> {
  const key = editMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Edit__MutationParameters) => Client.edit(data.id ?? options?.parameters?.id!, data.dto),
  mutationKey: key,
});
}
  
export function removeUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/measurements/mappings/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'MeasurementMappingClient',
      'remove',
      id as any,
    ]);
}

export function useRemoveMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = removeMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.remove(id),
    mutationKey: key,
  });
}
  
type Remove__MutationParameters = RemoveMeasurementMappingQueryParameters

export function useRemoveMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, Remove__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: RemoveMeasurementMappingQueryParameters}): UseMutationResult<void, unknown, Remove__MutationParameters, TContext> {
  const key = removeMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Remove__MutationParameters) => Client.remove(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}